import React from 'react'
import styled from "styled-components";

function Logout() {
    return (
        <Wrapper>
            Logged Out
        </Wrapper>
    )
};

const Wrapper = styled.div`
margin: 0px 0px;
height: 100vh;
width:100vw;
align-items:center
`

export default Logout
